module.exports = __webpack_public_path__ + "img/icon_img_07.26dc96c7.png";